const Preparation: React.FC = () => {
    return (
        <div id='NotFoundPage' className='page'>
            <h2>準備中・・・</h2>
            <p>準備中・・・</p>
        </div>
    );
};

export default Preparation;
